import { Dialpad } from "@mui/icons-material";
import { Dialog, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { baseURL } from "../utils/helper";

interface Props {
  open: boolean;
  onClosingVOCModal: () => void;
}

function VOCModal(props: Props) {
  const { open, onClosingVOCModal } = props;
  const [appreciationContent, setAppreciationContent] = useState("");
  async function getAppreciationContent() {
    try {
      const getAppreciationRequest = await fetch(
        `${baseURL}/fun/getAppreciationContent?fileName=Thanks .htm`,
        {
          method: "GET",
          headers: {
            "Content-Type": "text/plain",
          },
        }
      );
      const tempAppreciationContent = await getAppreciationRequest.text();
      setAppreciationContent(tempAppreciationContent);
      console.log("app content : ", tempAppreciationContent);
    } catch (error) {
      console.log("error in content : ", error);
    }
  }
  useEffect(() => {
    getAppreciationContent();
  }, []);
  return (
    <Dialog
      open={open}
      onClose={onClosingVOCModal}
      fullWidth={true}
      maxWidth="md"
    >
      <div style={{ padding: 10 }}>
        <div dangerouslySetInnerHTML={{ __html: appreciationContent }} />
      </div>
    </Dialog>
  );
}

export default VOCModal;
